import {
  type IOrganizationSchema,
  OrganizationSchema,
} from 'store/schemas/Organization';
import { Schema } from 'store/schemas/Schema';

interface INewsArticleSchema {
  headline?: string;
  url?: string;
  image?: string | null;
  datePublished?: string;
  author?: string;
  publisher?: IOrganizationSchema;
}

export class NewsArticleSchema extends Schema {
  headline;
  url;
  image;
  datePublished;
  author;
  publisher;

  constructor({
    headline,
    url,
    image,
    datePublished,
    author,
    publisher,
  }: INewsArticleSchema) {
    super();
    this.headline = headline;
    this.url = url;
    this.image = image;
    this.datePublished = datePublished;
    this.author = author;
    this.publisher = publisher;
  }

  toJSON() {
    return Schema.cleanse({
      '@context': 'http://schema.org',
      '@type': 'NewsArticle',
      headline: this.headline,
      url: this.url,
      image: this.image,
      datePublished: this.datePublished,
      author: this.author
        ? {
            '@type': 'Person',
            name: this.author,
          }
        : null,
      publisher: new OrganizationSchema(this.publisher).toJSON(),
    });
  }
}
